export function FooterView(props) {
    return (
        <div className="footer-container">
            <footer className="bg-dark">
                <h2>BeatMatch - Create a playlist with your friends!</h2>
            </footer>
        </div>
    );
}
